export default function loginModalController(
    loginRedirectPath,
    $scope,
    $rootScope,
    $location,
    $element,
    close,
    // userService,
    Auth,
    siteService
) {
    $scope.message = "";
    $scope.showLogin = true;
    $scope.showNewUser = false;
    // $scope.user = userService.user;
    $scope.siteService = siteService;

    // Missing ApiV3 Auth - But so far the modal is DEP
    // authService.isAuthenticated().then(function (result) {
    //     console.log(result);
    //     // if user is allready logged in
    //     if (result.data) {
    //         $location.path("/");
    //     } else {
    //         $scope.initPage();
    //     }
    // });

    //$scope.initPage = function () {
    // Terms page
    // siteService.getPage(91).then(function (result) {
    //     if (result.articleItems[0]) {
    //         $scope.sidebarContent = result.articleItems[0].articleSections[0];
    //     } else {
    //         $scope.sidebarContent = {
    //             headline: "[Missing title]",
    //             bodyHTML:
    //                 "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean rhoncus at lacus non rutrum. Integer elementum hendrerit libero vitae fermentum. Nunc venenatis malesuada mauris. Nam vulputate mi sed dolor dapibus, quis efficitur velit fringilla. Aliquam erat volutpat. Cras a hendrerit libero.",
    //         };
    //     }
    // });
    //}

    $scope.login = function () {
        $scope.modalClose("login-user");
    };

    $scope.createUser = function () {
        $scope.modalClose();
        $location.path("/account/create");
    };

    $scope.modalClose = function (someVar) {
        $element.modal("hide");
        close(someVar, 500); // close, but give 500ms for bootstrap to animate
    };
}
